import { useState } from "react";
import KenyaTeaser from "./KenyaTeaser";
import KenyaWorkFlow from "./KenyaWorkFlow";

export default function Main() {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return (
    <>
      {/* /////////////////////////////////////////////////////////////////////////////// */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className=" p-6 rounded shadow-lg  relative"
            onClick={(e) => e.stopPropagation()} // Empêche la fermeture en cliquant sur le contenu
          >
            {/* ///////////////////////////// */}
            <section className=" mt-20  reveal mb-10 from-green-600 rounded-lg to-blue-600 text-white">
              <div className="max-w-7xl py-16 mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="flex  flex-wrap justify-center gap-4">
                  <a
                    href="/mksp/guide/university"
                    className="bg-gray-900 rounded  dark:text-gray-100 text-gray-100 hover:bg-green-700 text-base px-8 py-3 h-auto"
                  >
                    Explorer les universités
                  </a>
                  <a
                    href="/mksp/guide"
                    className="border-white bg-green-700 rounded bgC  dark:text-gray-100 text-white hover:bg-green-900 text-base px-8 py-3 h-auto"
                  >
                    Consulter le guide premium
                  </a>
                </div>
              </div>
            </section>
            <button
              onClick={closeModal}
              className="px-4 py-2 text-white rounded hover:bg-green-700"
            >
              <svg
                className="w-6 h-6 text-gray-200 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18 17.94 6M18 18 6.06 6"
                />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* /////////////////////////////////////////////////////////////////////////////// */}
      <div className="max-w-screen-xl px-4 mx-auto 2xl:px-0 py-8">
        <div>
          <section className="relative shadow-xl ... reveal overflow-hidden  bg-surface">
            <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center py-10 px-4">
              <div className="space-y-4">
                <h1 className="text-3xl  sm:text-5xl lg:text-5xl font-extrabold leading-tight">
                  <span className=" text-green-700 dark:text-green-500">
                    My kenya Student <br /> Process{" "}
                  </span>
                  Votre guide idéal pour étudier au Kenya
                  <br />
                </h1>

                <div className="flex -mt-10  items-center gap-6 flex-wrap">
                  {/* <a href="#" className="bg-primary hover:bg-primary-dark dark:text-gray-200 font-medium px-10 py-3 rounded-full">Get&nbsp;Started</a>
          <a href="#" className="flex items-center gap-3 dark:text-gray-500 hover:text-primary font-medium">
            <span className="ring-2 ring-primary p-3 rounded-full inline-flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
            </span>
            Watch&nbsp;the&nbsp;video
          </a> */}
                </div>
                <div className="flex   items-center gap-4 ">
                  <div className="flex -space-x-3">
                    <img
                      src="https://images.pexels.com/photos/12496864/pexels-photo-12496864.jpeg?auto=compress&cs=tinysrgb&w=600"
                      className="w-10 h-10 rounded-full ring-2 ring-white"
                      alt="avatar"
                    />
                    <img
                      src="https://images.pexels.com/photos/14772808/pexels-photo-14772808.jpeg?auto=compress&cs=tinysrgb&w=600"
                      className="w-10 h-10 rounded-full ring-2 ring-white"
                      alt="avatar"
                    />
                    <img
                      src="https://images.pexels.com/photos/12497061/pexels-photo-12497061.jpeg?auto=compress&cs=tinysrgb&w=600"
                      className="w-10 h-10 rounded-full ring-2 ring-white"
                      alt="avatar"
                    />
                    <img
                      src="https://images.pexels.com/photos/12496863/pexels-photo-12496863.jpeg?auto=compress&cs=tinysrgb&w=600"
                      className="w-10 h-10 rounded-full ring-2 ring-white"
                      alt="avatar"
                    />
                  </div>
                  <svg
                    className="w-[30px] h-[30px] dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.5 8a4 4 0 0 0-4 4 2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3Zm6.82-3.096a5.51 5.51 0 0 0-2.797-6.293 3.5 3.5 0 1 1 2.796 6.292ZM19.5 18h.5a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-1.1a5.503 5.503 0 0 1-.471.762A5.998 5.998 0 0 1 19.5 18ZM4 7.5a3.5 3.5 0 0 1 5.477-2.889 5.5 5.5 0 0 0-2.796 6.293A3.501 3.501 0 0 1 4 7.5ZM7.1 12H6a4 4 0 0 0-4 4 2 2 0 0 0 2 2h.5a5.998 5.998 0 0 1 3.071-5.238A5.505 5.505 0 0 1 7.1 12Z" />
                  </svg>

                  <span className="text-gray-600">10k&nbsp;Enrolment</span>
                </div>
              </div>
              <div className="relative">
                <img
                  src="/img/etudiants.jpeg"
                  alt="Student"
                  className="rounded-xl shadow-lg max-h-[480px] w-full object-cover"
                />
                <div className="absolute -left-8 bottom-8 bg-white mt-10 shadow-lg rounded-lg px-5 py-2">
                  <span className="block text-4xl font-bold text-green-900 ">
                    +10
                  </span>
                  <span className="text-gray-700 font-bold uppercase text-xs tracking-widest">
                    Étudiants aidés
                  </span>
                </div>
                <svg
                  className="absolute -right-16 top-10 text-primary opacity-30"
                  width={140}
                  height={140}
                  viewBox="0 0 14 14"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="dots"
                      x={0}
                      y={0}
                      width={2}
                      height={2}
                      patternUnits="userSpaceOnUse"
                    >
                      <circle cx="0.5" cy="0.5" r="0.5" />
                    </pattern>
                  </defs>
                  <rect width={140} height={140} fill="url(#dots)" />
                </svg>
              </div>
            </div>
          </section>
        </div>
      </div>
      <KenyaTeaser />
      <div className="flex px-10 flex-col mt-10 mb-1 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
        <button onClick={openModal} className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-100 rounded-lg border bg-green-800 dark:bg-green-700 border-gray-300 hover:bg-green-900 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-900 dark:hover:bg-green-900 dark:focus:ring-gray-800">
          Commencer votre parcours
          <svg className="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
        </button>
      </div>

      <KenyaWorkFlow />
    </>
  );
}
